import './sigt-commenter-general/sigt-commenter-general.component';
import './sigt-commenter-plan-travail/sigt-commenter-plan-travail.component';
import './sigt-inscrire-commentaire/sigt-inscrire-commentaire.component';
import './sigt-rapport-commentaire/sigt-rapport-commentaire.component';
import './sigt-recherche-gdf/sigt-recherche-gdf.component';
import './sigt-recherche-rde/sigt-recherche-rde.component';
import './sigt-share-map-tool/sigt-share-map-tool.component';
import './sigt-spatial-filter/sigt-spatial-filter.component';
import './sigt-print-tool/sigt-print-tool.component';
import './sigt-extract-by-polygon/sigt-extract-by-polygon.component';
// Remplace l'outil « draw » d'igo2 (liste des dessins perdue au changement d'outil).
import './sigt-drawing-tool/sigt-drawing-tool.component';
